/** What the Platform Settings card shows while no row exists. The backend no longer reads that setting. */
export const DEFAULT_VM_CPU_LIMIT_RATIO = 1;

/** Mirrors VmCpuUsage.DefaultLimitRatio — the ratio of a VM whose product line stores none. */
export const DEFAULT_PRODUCT_LINE_CPU_LIMIT_RATIO = 0.7;

/** Same rule as VmCpuUsage.TryParseLimitRatio: a dot-decimal number in (0, 1]. */
export function parseVmCpuLimitRatio(value: string): number | null {
  const trimmed = value.trim();
  if (!/^\d*\.?\d+$/.test(trimmed)) return null;
  const ratio = Number(trimmed);
  return ratio > 0 && ratio <= 1 ? ratio : null;
}

/** Mirrors ProductLine.DefaultNetworkRate — the port speed (MB/s) of a VM whose product line stores none. */
export const DEFAULT_PRODUCT_LINE_NETWORK_RATE = 13;

/** Mirrors ProductLine.MaxNetworkRate. */
export const MAX_PRODUCT_LINE_NETWORK_RATE = 10000;

/** Same rule as ProductLine.IsValidNetworkRate: a dot-decimal number above 0 and at most the maximum. */
export function parseProductLineNetworkRate(value: string): number | null {
  const trimmed = value.trim();
  if (!/^\d*\.?\d+$/.test(trimmed)) return null;
  const rate = Number(trimmed);
  return rate > 0 && rate <= MAX_PRODUCT_LINE_NETWORK_RATE ? rate : null;
}
